import { Pipe, PipeTransform } from '@angular/core';
import {
    CaseModuleId,
    CMOrderModuleId,
    CustomerRMAModuleId,
    EstimateOrderModuleId,
    InvoiceOrderModuleId,
    OpportunityModuleId,
    SOModuleId,
    TaskModuleId,
} from '../constants/modules.constant';
import { DecimalPipe } from '@angular/common';
import { CurrencySymbolPipe } from './currency-symbol.pipe';

@Pipe({ name: 'activityModuleDetails', pure: true })
export class ActivityModuleDetailsPipe implements PipeTransform {
    constructor(private decimalPipe: DecimalPipe,
        private currencySymbol: CurrencySymbolPipe
    ) { }

    transform(activityDetails: any): any {
        let moduleDetails: string = '';
        switch (activityDetails?.moduleData?.objectId) {
            case OpportunityModuleId:
                moduleDetails = `Opportunity - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.currencySymbol.transform(this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    ))}`;
                break;

            case CaseModuleId:
                    moduleDetails = `Case - Stage: ${activityDetails?.moduleData?.stageName||''}`;
                break;
            case TaskModuleId:
                    moduleDetails = `Task - Stage: ${activityDetails?.moduleData?.stageName||''}`;
                break;

            case SOModuleId:
                moduleDetails = `SalesOrder - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    )}`;
                break;
            case InvoiceOrderModuleId:
                moduleDetails = `Invoice - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    )}`;
                break;
            case CustomerRMAModuleId:
                moduleDetails = `CustomerRMA - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    )}`;
                break;
            case CMOrderModuleId:
                moduleDetails = `CreditMemo - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    )}`;
                break;
            case EstimateOrderModuleId:
                moduleDetails = `Estimate - Stage: ${activityDetails?.moduleData?.stageName || ''
                    }, Amount: ${this.decimalPipe.transform(
                        activityDetails?.moduleData?.amount || 0,
                        '1.2-2'
                    )}`;
                break;
            default:
                break;
        }

        return moduleDetails;
    }
}
